// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UserCard-cls1___8018a5a7952c73eef85{/*!*/}.UserCard-cls2__c1f695b7ea580437f749{--avatar-size: 40px;display:grid;grid-column-gap:8px;-moz-column-gap:8px;column-gap:8px;grid-template-columns:var(--avatar-size) 1fr}.UserCard-cls2__c1f695b7ea580437f749 a,.UserCard-cls2__c1f695b7ea580437f749 div{grid-row:1/3;width:100%}.UserCard-cls2__c1f695b7ea580437f749.UserCard-small__cfca5b4e75d0b7a8aa29{--avatar-size: 24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "UserCard-cls1___8018a5a7952c73eef85",
	"cls2": "UserCard-cls2__c1f695b7ea580437f749 UserCard-cls1___8018a5a7952c73eef85",
	"small": "UserCard-small__cfca5b4e75d0b7a8aa29"
};
export default ___CSS_LOADER_EXPORT___;
